import React from "react";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { useTheme } from "../../../../core/contexts/ThemeContext";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    // backgroundColor: "#f68c23",
    // color: "#fff",
    textAlign: "center",
    // borderTopLeftRadius: "1rem",
    // borderTopRightRadius: "1rem"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    //color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  const { rucmonkeyTheme } = useTheme();

  if (!rucmonkeyTheme) return null;

  return (
    <MuiDialogTitle
      disableTypography
      className={classes.root}
      style={{
        backgroundColor: rucmonkeyTheme.primaryColorCode,
        color: rucmonkeyTheme.textColorCode,
      }}
      {...other}
    >
      <Typography variant="h5">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export default DialogTitle;